import { Box, Typography } from '@mui/material';
import {
  staticContent,
  UserStateContextType
} from 'components/constants/Constants';
import { Breadcrumbs } from 'components/pages/products/Breadcrumbs';
import { useUserState } from 'context/User';
import React from 'react';

import { useParams } from 'react-router-dom';

import { tss } from 'tss-react/mui';
const createBreadcrumbs = (event: string, title: string) => ({
  links: [
    {
      link: `/admin/event/${event}/dashboard`,
      title: 'Admin'
    }
  ],
  active: title
});
const AdminPagesHeader: React.FC<{ title: string }> = ({ title }) => {
  const { event } = useParams();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <Box>
        {event && <Breadcrumbs breadcrumbs={createBreadcrumbs(event, title)} />}
        <Typography variant="h3">{title}</Typography>
      </Box>
    </Box>
  );
};

export default AdminPagesHeader;

export const AdminHeaderCompanyLogo = ({ event }: { event?: string }) => {
  const userState = useUserState();
  const { classes } = useStyles();
  const eventInfo =
    userState.type === UserStateContextType.AUTHENTICATED
      ? userState.user.brandPortalEvent?.find(e => e.key === event)
      : undefined;
  const eventImage = eventInfo?.images?.find(
    el => el.section === 'LOGO'
  )?.reference;
  if (!eventImage) return null;
  return (
    <img
      src={`${staticContent}/events/${event}/${
        eventInfo?.images?.find(el => el.section === 'LOGO')?.reference
      }`}
      className={classes.img}
      alt={`${eventInfo?.name ?? ''} Logo`}
    />
  );
};

const useStyles = tss.create(({ theme }) => ({
  img: {
    objectFit: 'contain',
    height: 70,

    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
